import { ProjectType } from '../../../data/gql-gen/dashboard/graphql'
import { useProjectData } from '../Project.hooks'
import ProjectTitleAndStatus from './ProjectNameAndStatus.component'
import ProjectTitleAndStatusLoading from './ProjectNameAndStatus.loading'

const ProjectNameAndStatus = () => {
  const { project, loading: projectLoading } =
    useProjectData('cache-and-network')

  if (projectLoading) {
    return <ProjectTitleAndStatusLoading />
  }

  const projectName = project?.name ?? '...'

  const projectStatus = project?.surveys[0].state ?? 'draft'
  const projectType = project?.projectType ?? ProjectType.AdHoc

  return (
    <ProjectTitleAndStatus
      projectId={project?.projectId}
      projectName={projectName}
      projectStatus={projectStatus}
      projectType={projectType}
    />
  )
}

export default ProjectNameAndStatus
